import React from 'react'
import DomainLayoutContainer from './DomainLayoutContainer'

const Layout = (props) => (
  <DomainLayoutContainer {...props} />
)

export default Layout



// WEBPACK FOOTER //
// src/layouts/Domain/index.js